export const styles = {
  global: {
    // styles for the `body`
    body: {},
    ".js-focus-visible :focus:not(.focus-visible)": {
      shadow: "none",
    },
  },
};
